import Image from 'next/image';
import Icon from './add_white.svg?url';
import type { SvgImageProps } from '../_type';

export const AddWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={Icon} alt={alt} {...props} />
);
